import { Configuration } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';
import { getHeaderManifest } from '@carvana/header';

function mfeCacheBuster() {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;

  return `${date.getDate()}${date.getHours()}${nearestQuarterHour}`;
}

export const config: Configuration = {
  name: 'mycarvanaui',
  debug: false,
  Render: MfeReact(),
  ENV: process.env.NODE_ENV as any,
  globals: {
    React: () => import('react'),
    ReactDOM: () => import('react-dom'),
    styled: () => import('styled-components'),
    'styled-components': () => import('styled-components'),
    PropTypes: () => import('prop-types'),
    'prop-types': () => import('prop-types'),
    CarvanaCoreAuth: () => import('@carvana/core-auth'),
  },
  files: [
    [
      'HeaderModule',
      [
        {
          component: 'default',
          default: {
            file: 'index.js',
            manifest: getHeaderManifest(process.env.NODE_ENV),
          },
        },
      ],
    ],
    [
      'FooterModule',
      [
        {
          component: 'default',
          browser: true,
          default: {
            file: 'index.js',
            manifest: `${
              process.env.CARVANA_APP_CDN_URL_FASTLY
            }/footer/module/assets-manifest.json?v=${mfeCacheBuster()}`,
          },
        },
      ],
    ],
    [
      'CustomerRegistrationMFE',
      [
        {
          component: 'default',
          default: {
            file: 'index.js',
            manifest: `${
              process.env.CARVANA_APP_CDN_URL_STATIC_FASTLY
            }/customer-components/mfe/customer-registration/assets-manifest.json?v=${mfeCacheBuster()}`,
          },
          css: {
            files: ['styles.css'],
          },
        },
      ],
    ],
    [
      'CustomerRegistrationBannerMFE',
      [
        {
          component: 'default',
          default: {
            file: 'index.js',
            manifest: `${
              process.env.CARVANA_APP_CDN_URL_STATIC_FASTLY
            }/customer-components/mfe/customer-registration-banner/assets-manifest.json?v=${mfeCacheBuster()}`,
          },
          css: {
            files: ['styles.css'],
          },
        },
      ],
    ],
  ],
};

export default config;
